<template>
    <div class="abschluss-fehler-box px-4 py-5 p-md-5 d-flex flex-column justify-content-center align-items-center">
        <grosser_fehler></grosser_fehler>
        <div class="mt-5 mb-4">
            <b>Leider konnte Ihre Anfrage nicht verarbeitet  werden.</b>
        </div>

        <div class="abschluss-fehler-info-box px-4 py-3 px-md-5 py-md-4 w-100">
            <b>Kontaktieren Sie uns bitte telefonisch unter
                <template v-if="isAokAntrag">0211 355900-77.</template>
                <template v-else>0211 355900-0.</template>
            </b><br>
        </div>
        <div class="abschluss-fehler-info-box px-4 py-3 px-md-5 py-md-4 w-100 mt-3">            
            <b>Aufgetretener Fehler:</b><br>
            <pre>{{ formattedErrorMessage }}</pre>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useVertragStore } from '@/stores/vertrag.js';
import { useRechnerStore } from '@/stores/rechner';
import { useMainStore } from '@/stores/useMainStore.js';
import grosser_fehler from '@/components/icons/grosser_fehler_icon.vue';

const vertragStore = useVertragStore();
const store = useRechnerStore();
const mainStore = useMainStore();

const isAokAntrag = computed(() => mainStore.aokEnabled && store.aok !== 0);

/**
 * Formatiert die Fehlermeldung:
 * 1. Entfernt "Fehler: " am Anfang (nur bei der ersten Zeile)
 * 2. Pro Zeile: Wenn die Zeile ein "-" und ein ":" enthält, wird der ":" nach dem "-" durch ein Leerzeichen ersetzt
 */
const formattedErrorMessage = computed(() => {
    if (!vertragStore.errorMessage) {
        return '';
    }
    
    // Teile die Nachricht in Zeilen auf
    const lines = vertragStore.errorMessage.split('\n');
    
    // Verarbeite jede Zeile einzeln
    const formattedLines = lines.map((line, index) => {
        let processedLine = line.trim();
        
        // Entferne "Fehler: " nur bei der ersten Zeile (case-insensitive)
        if (index === 0) {
            processedLine = processedLine.replace(/^Fehler:\s*/i, '');
        }
        
        // Wenn die Zeile ein "-" und ein ":" enthält, ersetze den ":" nach dem "-" durch ein Leerzeichen
        const dashIndex = processedLine.indexOf('-');
        const colonIndex = processedLine.indexOf(':');
        
        if (dashIndex !== -1 && colonIndex !== -1 && colonIndex > dashIndex) {
            // Ersetze den ":" durch ein Leerzeichen
            processedLine = processedLine.substring(0, colonIndex) + ' ' + processedLine.substring(colonIndex + 1).trim();
        }
        
        return processedLine;
    });
    
    // Füge die Zeilen wieder zusammen
    return formattedLines.filter(line => line.length > 0).join('\n');
});
</script>

<style scoped>
pre {
    font-size: inherit;
    font-family: inherit;
    
}
</style>